<template>
  <div class="min-h-screen bg-gray-100">
    <Navigation></Navigation>
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3">
      <Breadcrumbs></Breadcrumbs>
    </div>
    <div class="py-10">
      <header>
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <slot name="header"></slot>
        </div>
      </header>
      <main>
        <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
          <div class="px-4 py-8 sm:px-0">
            <slot></slot>
          </div>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import Navigation from '@/components/Partials/Navigation.vue'
import Breadcrumbs from '@/components/Breadcrumbs.vue'

export default {
  name: 'home',
  components: {
    Navigation,
    Breadcrumbs,
  },
  methods: {
    navigateTo: function(url) {
      this.$router.push(url);
    }
  },
}
</script>
